module.exports = __webpack_public_path__ + "static/media/blank.8b560091.jpg";